var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocationHomeStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "14px",
    viewBox: "0 0 10 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLocationHomeStream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.14,0.56 C7.51596193,0.56 9.48,2.31796988 9.48,4.84096544 C9.48,5.75463412 9.2209229,6.73199243 8.801875,7.46701807 L5.4212963,13.3979447 C5.36466327,13.4988674 5.25694248,13.5614999 5.14,13.5614999 C5.02305752,13.5614999 4.91533673,13.4988674 4.8587037,13.3979447 L1.478125,7.46701807 C1.05909318,6.73202414 0.8,5.75463412 0.8,4.84096544 C0.8,2.31796988 2.76403807,0.56 5.14,0.56 Z M5.14,2.77975904 C3.98973283,2.77975904 3.05037037,3.70636573 3.05037037,4.84096544 C3.05037037,5.97557942 3.98973604,6.90216867 5.14,6.90216867 C6.29026396,6.90216867 7.22962963,5.97557942 7.22962963,4.84096544 C7.22962963,3.70636573 6.29026717,2.77975904 5.14,2.77975904 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icLocationHomeStream",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationHomeStream);
export default __webpack_public_path__ + "static/media/icLocationHomeStream.fa06cf18ce193c75cf60958d610d85ad.svg";
export { ForwardRef as ReactComponent };